/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryProviderAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class QueryProviderAPI {

		/**
		 * @function QueryProviderAPI#getQuerySpecList
		 * @description Get an array of objects with query id, type and spec.
		 * @public
		 *
		 * @return {Object[]} An array of objects with query id, type and spec.
		 * @example
		 * [{
		 *    'id': 'layerId1',
		 *  'type': 'main',
		 *  'spec': {
		 *   'projections': []
		 *   ...
		 *   }
		 * },
		 * {
		 *    'id': 'layerId',
		 *  'type': 'main.minmax',
		 *  'spec': {
		 *   ...
		 *   }
		 * }]
		 */
		getQuerySpecList() {}

		/**
		 * @return {String} the type of the provider
		 */
		getType() {}
	}

	return QueryProviderAPI;
});
